<template>
  <!-- modal starts -->
  <div class="patient__login__modal__wrapper">
    <div class="patient__login__modal__container">
      <div class="modal__title d-flex justify-content-between py-2 px-3">
        <h4 class="my-0">{{ modalText }}</h4>
        <div class="col-lg-2">
            <span class="tooltip-wrapper pointer" @click.prevent="onclosed()" style="float:right">
          <i class="fa fa-times cursor-pointer" ></i>
           <span class="custom-tooltip closetooltipposition">Close</span>
           </span>
        </div>
      </div>
      <div class="px-5 py-3">
  <div v-if="modalText == `Sign`">
    <h7> On signing, this is equivalent to the wet ink signature </h7>
  </div>
  <div v-if="emailValidation" class="form-group mb-4">
    <label class="col-form-label">
      {{$t("navigations.email")}}<sup><i class="fa fa-asterisk required"></i></sup>
    </label>
    <input type="text" class="form-control" maxlength="500" v-model="emailId" />
    <span v-if="emailValidation" class="errmsg">{{ emailError }}</span>
  </div>
  <div v-else class="form-group ">
    <label class="col-form-label">
      {{ $t("navigations.email") }}
      <sup><i class="fa fa-asterisk required"></i></sup>
    </label>
    <input type="text" class="form-control" maxlength="500" v-model="emailId" />
    <span v-if="emailValidation" class="errmsg">{{ emailError }}</span>
  </div>
  <div class="form-group position-relative">
    <label class="col-form-label">{{ $t("navigations.password")
      }} <sup><i class="fa fa-asterisk required"></i></sup></label>
    <input :type="inputType" class="form-control" maxlength="500" v-model="password" />
    <i class="password-sign-visible-block cursor-pointer position-absolute"
      :class="[visibleOn ? 'fa fa-eye' : 'fa fa-eye-slash']" @click.prevent="passwordVisible()"></i>
    <div>
      <span v-if="passwordValidation" class="errmsg">{{ passwordError }}</span>
      <span v-if="formError" class="errmsg">{{ formError }}</span>
    </div>
  </div>
  <div class="d-flex justify-content-between">
    <button class="save_btn px-5 mt-3" :disabled="isSubmitting" @click="submitClick(false)">
      <span v-if="isSubmitting && submittingAction === 'sign'" class="spinner-border spinner-border-sm mr-1" role="status"
        aria-hidden="true"></span>
      <span>{{ $t("navigations.sign") }}</span>
    </button>
    <button class="save_btn px-5 mt-3" :disabled="isSubmitting" @click="submitClick(true)">
      <span v-if="isSubmitting && submittingAction === 'signAndComplete'" class="spinner-border spinner-border-sm mr-1" role="status"
        aria-hidden="true"></span>
      <span>{{ $t("navigations.sign and complete") }}</span>
    </button>
  </div>
</div>
      <!-- test -->
    </div>
  </div>
  <!-- modal ends -->
</template>
<script>
import axios from "axios";
import store from "../../store/index";
import jwt_decode from "jwt-decode";
export default {
  name: "signaturePopUp",
  props: {
    status: {
      type: String,
      default: "",
    },
    formId: {
      type: String,
      default: "",
    },
    modalText: {
      type: String,
      default: "",
    },
    fromSrcUrl: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      inputType: "password",
      visibleOn: false,
      emailId: "",
      password: "",
      err: "",
      formError: "",
      emailError: "", // Email-specific error
      passwordError: "", // Password-specific error
      emailValidation: false, // Email validation flag
      passwordValidation: false, // Password validation flag
      id: "",
      state: "",
      baseurl: process.env.VUE_APP_Service_URL,
      userloginId:"",
      isSubmitting: false,
      submittingAction: "",
    };
  },
  async mounted() {
    await this.assignValues();
    await this.getuseridwitauthid();
  },
  methods: {
    async getuseridwitauthid(){
       const idtoken = store.getters.getIdToken;
      const jwtDecodedauthid = jwt_decode(idtoken).sub;
await axios
          .get(
            `${this.baseurl}/account-core/user/getuserwithauthid?id=${jwtDecodedauthid}`,
            {
              headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "application/json",
              },
            }
          )
          .then((res) => {
            this.userloginId = res.data[0].id;
          })
          .catch((err) => {
            console.log("error",err);
          });
    },
    async passwordVisible() {
      this.visibleOn = !this.visibleOn;
      if (this.visibleOn === true) {
        this.inputType = "text";
      } else this.inputType = "password";
    },
    async assignValues() {
      this.id = this.formId;
      this.state = this.status;
      console.log("FormID=>", this.id + "&" + "Status=>", this.state);
    },
    async onclosed() {
      this.$emit("signatureclosemodelpopup");
      this.emailId = "";
      this.password = "";
      this.resetSignatureErrors();
    },

    async submitClick(iscomplete) {
      if (this.isSubmitting) {
        return;
      }

      this.resetSignatureErrors();

      if (this.emailId == "") {
        this.emailError = this.$t("navigations.please enter a valid email id"); // Set specific email error
        this.emailValidation = true; // Trigger email error
      }

      if (this.password == "") {
        this.passwordError = this.$t("navigations.please enter your password");// Set specific password error
        this.passwordValidation = true; // Trigger password error
      }

      if (!this.emailValidation && !this.passwordValidation) {
        await this.updateSign(iscomplete);
      }
    },
    resetSignatureErrors() {
      this.formError = "";
      this.emailError = "";
      this.passwordError = "";
      this.emailValidation = false;
      this.passwordValidation = false;
    },
    getSignatureErrorMessage(err) {
      let errorData = err && err.response ? err.response.data : null;

      if (typeof errorData === "string") {
        try {
          errorData = JSON.parse(errorData);
        } catch {
          return errorData;
        }
      }

      const domainValidations =
        errorData &&
        errorData.errors &&
        errorData.errors.DomainValidations;

      if (Array.isArray(domainValidations) && domainValidations.length > 0) {
        return domainValidations[0];
      }

      return (
        (errorData && errorData.detail) ||
        (errorData && errorData.title) ||
        (err && err.message) ||
        "Unable to sign the form. Please try again."
      );
    },
    handleSignatureError(err) {
      const errorMsg = this.getSignatureErrorMessage(err);
      const normalizedErrorMsg = String(errorMsg || "").toLowerCase();

      if (
        normalizedErrorMsg.includes("email id entered differs") ||
        (
          normalizedErrorMsg.includes("email") &&
          normalizedErrorMsg.includes("authenticated user")
        )
      ) {
        this.emailError = this.$t("navigations.email id entered differs from the logged in users email id");
        this.emailValidation = true;
        return;
      }

      if (normalizedErrorMsg.includes("invalid email or password")) {
        this.passwordError = "Invalid email or password.";
        this.passwordValidation = true;
        return;
      }

      if (normalizedErrorMsg.includes("invalid password")) {
        this.passwordError = this.$t("navigations.invalid password");
        this.passwordValidation = true;
        return;
      }

      if (normalizedErrorMsg.includes("user not found")) {
        this.formError = "User not found";
        return;
      }

      if (normalizedErrorMsg.includes("user has not created a signature")) {
        this.passwordError = this.$t("navigations.user has not created a signature");
        this.passwordValidation = true;
        return;
      }

      this.formError = String(errorMsg || "Unable to sign the form. Please try again.");
    },
    async updateSign(iscomplete = false) {
      if (this.isSubmitting) {
        return;
      }

      this.isSubmitting = true;
      this.submittingAction = iscomplete ? "signAndComplete" : "sign";
      const idtoken = store.getters.getIdToken;
      const consentRecordId = localStorage.getItem("consentRecordId");
      const roledata = store.getters.getRolesData;
      console.log("roledata",roledata);

      try {
        if (this.fromSrcUrl === "digitalForm") {
          await axios
            .put(
              `${this.baseurl}/forms/template/signtemplate?TempId=${this.id}&status=${this.state}&email=${this.emailId}&password=${this.password}`,
              {},
              {
                headers: {
                  Authorization: "Bearer " + idtoken,
                  "Content-Type": "application/json",
                },
              }
            )
            .then((res) => {
              this.refreshForm("test");
              this.$emit("signatureclosemodel");
              if (this.status == "Signed") {
                this.$emit("docSigned");
                localStorage.removeItem("setId");
                localStorage.removeItem("showSign");
              }
            })
            .catch((err) => {
              console.log(err);
              this.handleSignatureError(err);
            });
        } else {
          await axios
            .put(
              `${this.baseurl}/account-core/user/signconsentform?loginId=${this.userloginId}&status=${this.state}&email=${this.emailId}&password=${this.password}&consentRecordId=${consentRecordId}`,
              {},
              {
                headers: {
                  Authorization: "Bearer " + idtoken,
                  "Content-Type": "application/json",
                },
              }
            )
            .then((res) => {
              this.refreshForm("test");
              if(iscomplete){
                  this.$emit("docSignedCompletedclose");
                }
                else{
              this.$emit("signatureclosemodel");
              }
            })
            .catch((err) => {
              this.handleSignatureError(err);
            });
        }
      } finally {
        this.isSubmitting = false;
        this.submittingAction = "";
      }
    },
    async refreshForm(test) {
      await store.dispatch("setFormRefresh", true);
      window.dispatchEvent(
        new CustomEvent("FormDigitalSignature", {
          detail: {
            storage: store.getters.getFormRefresh,
          },
        })
      );
    },
  },
};
</script>
<style scoped>
@import "../../assets/style.css";
@import "../../assets/formpage.css";

.previousbtn,
.nextbtn {
  margin: 0;
  border-radius: 0px;
  border: 0.5px solid #eeeeee;
}

.page-links {
  border-radius: 0px;
}

/*pagination styles*/
.pagination {
  margin: 0;
}

.Page,
.PaginationControl {
  border: 1px solid #e7eaec;
}

.Page-active {
  padding: .6rem;
  color: #ffffff;
  border: 1px solid var(--pagination-active-clr);
  border-radius: inherit;
  margin: 0;
}

.Page {
  padding: .6rem;
  border-radius: inherit;
  margin: 0;
}

.PaginationControl {
  padding: 0.07rem;
}

.modelbody {
  overflow: unset !important;
  background-color: #ffffff !important;
}

.modelbody {
  /* background-color: aquamarine; */
  margin: 0;
  padding: 5%;
}

.form-control {
  padding: 0.2rem 0.75rem !important;
}

.form-select {
  border-radius: 0 !important;
  padding: 0.2rem 0.75rem !important;
}

.form-select:focus {
  border-color: #145faf !important;
  box-shadow: 0 0 0 !important;
}

.patient__login__modal__wrapper {
  position: fixed;
  inset: 0;
  background: rgb(0 0 0 / 18%);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  z-index: 3000;
}

.patient__login__modal__container {
  position: fixed;
  width: min(500px, 90%);
  border-radius: 4px;
  background: #fff;
  overflow-x: hidden;
}

.modal__title {
  background-color: var(--pop-up-background);
  color: white;
}

.errmsg {
  font-size: 14px;
  color: red;
  display: block;   /* was: float: left */
  clear: both;
  margin-top: 4px;
}
.d-flex.justify-content-between {
  clear: both;
  gap: 12px; /* keeps Sign / Sign and Complete apart even if flex shrinks */
}
.save_btn {
  flex: 1;
}
.password-sign-visible-block {
  right: 11px;
  top: 36px;
}
.signature-error {
  color: #dc3545;
  background: #fdecea;
  border: 1px solid #f5c2c7;
  border-radius: 4px;
  padding: 8px 12px;
  margin-bottom: 12px;
  font-size: 14px;
}
.errmsg {
  font-size: 14px;
  color: red;
  display: block;
  clear: both;
  margin-top: 4px;
}

</style>
